// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","BrandListItem__icon":"uy_a bho_ke","BrandListItem__name":"uy_b bho_vp"};